/* eslint-disable */
import React, {Component} from 'react';
import './style.less';
import {Button, Icon} from 'antd';

export default class NewsImgCon extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    showMore(key) {
        if (this.props.showMore) {
            this.props.showMore(key);
        }
    }

    getMenuIndex(index) {
        let newIndex=0;
        switch (index) {
            case 0:newIndex=10;break;
            case 1:newIndex=11;break;
            case 2:newIndex=12;break;
            case 3:newIndex=13;break;
        }
        return newIndex
    }

    render() {
        const {title, list, showBottom,} = this.props;


        return (
            <div className={"newsImgCon"}>
                <div className="content0">
                    <div className="title-wrapper">
                        <h1 className={"title"}><p>{title}&nbsp;</p></h1>
                    </div>
                </div>
                {list && list.length > 0 && list.map((item, index) => {
                    return (
                        <div className={"imgCon"}
                             onClick={()=>this.showMore(this.getMenuIndex(index))}
                             key={index}>
                            <a className={'line1'}>
                                <img src={item['img']} className={"img"}/>
                                {item.icon ?
                                    <img src={item.icon} className={"icon-img"}/>
                                    : <Icon type="bar-chart" width={6}
                                            height={6}/>}

                                <p className={"text"} style={{textAlign:"center"}}>{item['text']}</p>
                            </a>
                        </div>
                    )
                })}
                {
                    showBottom &&
                    <div className={"bottom"}>
                        <img onClick={() => this.showMore(0)}
                             style={{width:80,height:36,margin:10}}
                             src="/img/moreBtn.png"/>
                    </div>
                }

            </div>
        )
    }
}

